import { Console } from "console";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";

@ModuleName("Unsubscribe")
export class Unsubscribe implements AxInit {

    private token: string;

    AxInit(token: string): void {
        console.log(token);

        this.token = token;

        let that = this;

        $(".ax-btn.ax-btn-primary").on("click", function () {
            that.Unsubscribe();
        });
    }

    Unsubscribe() {
        let urlPath = window.location.pathname.toLowerCase().replace("manage", "unsubscribe");
        let unsubscribeUrl = urlPath + window.location.search;
        window.location.href = unsubscribeUrl;
    }

}